import React, { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentReturn({ cancel }) {
  const [state, setState] = useState(cancel ? "cancel" : "polling");
  const [link, setLink] = useState("");

  useEffect(() => {
    if (cancel) return;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const tick = async () => {
      tries += 1;
      try {
        const { data } = await axios.get(`${API}/public/checkout/status/${sid}`);
        if (data.payment_status === "paid") { setLink(data.access_link || ""); setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      if (tries >= 20) { setState("timeout"); return; }
      setTimeout(tick, 2000);
    };
    tick();
  }, [cancel]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#081325] px-4 text-white">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0F213A] p-8 text-center" data-testid="payment-return">
        {state === "polling" && (<><Loader2 className="mx-auto h-12 w-12 animate-spin text-emerald-400" /><h2 className="mt-4 text-lg font-bold">Confirmando seu pagamento...</h2><p className="mt-1 text-sm text-slate-400">Aguarde um instante.</p></>)}
        {state === "paid" && (<>
          <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-400" data-testid="payment-ok" />
          <h2 className="mt-4 text-xl font-bold">Matrícula confirmada!</h2>
          <p className="mt-2 text-sm text-slate-400">Enviamos o acesso para o seu e-mail. Você já pode iniciar o treinamento agora.</p>
          {link && <a href={link} className="mt-5 inline-flex items-center rounded-full bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700" data-testid="payment-access">Acessar meu treinamento <ArrowRight className="ml-1.5 h-4 w-4" /></a>}
        </>)}
        {state === "cancel" && (<><XCircle className="mx-auto h-14 w-14 text-amber-400" /><h2 className="mt-4 text-lg font-bold">Pagamento cancelado</h2><p className="mt-1 text-sm text-slate-400">Nenhuma cobrança foi feita.</p><a href="/cursos" className="mt-5 inline-block text-sm font-semibold text-emerald-400 hover:underline">Voltar aos cursos</a></>)}
        {(state === "error" || state === "timeout") && (<><XCircle className="mx-auto h-14 w-14 text-rose-400" /><h2 className="mt-4 text-lg font-bold">Não foi possível confirmar</h2><p className="mt-1 text-sm text-slate-400">Se o valor foi cobrado, verifique seu e-mail — o acesso é enviado automaticamente.</p><a href="/cursos" className="mt-5 inline-block text-sm font-semibold text-emerald-400 hover:underline">Voltar aos cursos</a></>)}
        {state !== "cancel" && <p className="mt-6 text-[11px] text-slate-600">Desenvolvido por Leandro Américo</p>}
      </div>
    </div>
  );
}
